import { IncomeSource } from 'further-types/investor';

export const IncomeSourceLabels = {
  [IncomeSource.EmploymentIncome]: 'Employment income',
  [IncomeSource.PensionsAndRetirementFunds]: 'Pensions and retirement funds',
  [IncomeSource.LegalSettlements]: 'Legal settlements',
  [IncomeSource.BusinessProfits]: 'Business profits',
  [IncomeSource.InvestmentsAndSavings]: 'Investments and savings',
  [IncomeSource.Inheritance]: 'Inheritance',
  [IncomeSource.SaleOfAssets]: 'Sale of assets',
  [IncomeSource.Gifts]: 'Gifts',
};
